
export const RestrictType = {
  numbers: 'numbers',
  letters: 'letters',
  alphanumeric: 'alphanumeric',
  phone: 'phone',
  password: 'password',
  email: 'email'
} as const;

export type RestrictType =
  typeof RestrictType[keyof typeof RestrictType];

// Limpiar inputs
export const RestrictRemovePatterns: Record<RestrictType, RegExp> = {
  numbers: /[^0-9]/g,
  letters: /[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g,
  alphanumeric: /[^a-zA-Z0-9]/g,
  phone: /[^0-9+]/g,
  password: /\s/g,
  email: /[^a-zA-Z0-9@._+-]|\s/g
};

// Bloquear Inputs
export const RestrictAllowedCharPatterns: Record<RestrictType, RegExp> = {
  numbers: /^[0-9]$/,
  letters: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ ]$/,
  alphanumeric: /^[a-zA-Z0-9]$/,
  phone: /^[0-9+]$/,
  password: /^[^\s]$/,
  email: /^[a-zA-Z0-9@._+-]$/
};